"use strict";

var Voyage = function () {

  var set_vehicle_view = function() {
    if ($('#road_voyage_contract_type').val() == 'owned') {
      $('#road_voyage_owned_vehicle').show();
      $('#road_voyage_rented_vehicle').hide();
    } else {
      $('#road_voyage_owned_vehicle').hide();
      $('#road_voyage_rented_vehicle').show();
    }
  }

  var set_truck_trailer_driver = function() {
    if ($('#rorotruck_rorotruck_type').val() == 'only_trailer') {
      $('#rorotruck_trailer_id').show();
      $('#rorotruck_truck_id').hide();
      $('#rorotruck_driver_id').hide();
    } else if($('#rorotruck_rorotruck_type').val() == 'trailer_truck') {
      $('#rorotruck_trailer_id').show();
      $('#rorotruck_truck_id').show();
      $('#rorotruck_driver_id').hide();
    } else {
      $('#rorotruck_trailer_id').show();
      $('#rorotruck_truck_id').show();
      $('#rorotruck_driver_id').show();
    }
  }

  var set_positions_view = function() {
    if ($('#road_voyage_voyage_type').val() == 'position_delivery') {
      if ($('#road_voyage_trailer_id').val() != '') {
        get_trailer_positions();
      }
      $('#road_voyage_status_div').show();
    } else {
      $('#positions_list').html('');
      $('#road_voyage_status_div').hide();
    }
  }

  var get_trailer_positions = function() {
    var trailer_id = $('#road_voyage_trailer_id').val();
    if (trailer_id != '') {
      $.ajax({
        type: "GET",
        url: "/positions?trans_method=road&list_scope=road_voyages&vessel_id=" + trailer_id,
        dataType: "script",
      });
    }
  }

  var set_sms_view = function() {
    if ($('#road_voyage_send_sms_message').is(':checked')) {
      $('#sms_details').show();
    } else {
      $('#sms_details').hide();
    }
  }

  // var get_trailer_positions = function() {
  //   $('#manifesto_trailer_coun').val($('#manifesto_trailer_id').select2('data')[0]['country_id']).trigger('change');
  //   $('#manifesto_vehicle_coun').val($('#manifesto_trailer_id').select2('data')[0]['country_id']).trigger('change');
  // }

  // var set_vehicle_infos = function() {
  //   $('#manifesto_trailer_coun').val($('#manifesto_vehicle_id').select2('data')[0]['country_id']).trigger('change');
  //   $('#manifesto_vehicle_coun').val($('#manifesto_vehicle_id').select2('data')[0]['country_id']).trigger('change');
  // }

  // var set_status_input_fields = function() {
  //   $('.manifesto_status_fields').hide();
  //   new_status = $('#manifesto_status').val();
  //   if (new_status != '') {
  //     if (new_status != 'rejected' && new_status != 'waiting') {
  //       $('#'+ new_status +'_input_field').show();
  //     } else {
  //       $('#cancelled_input_field').show();
  //     }
  //   }
  // }

  return {
    init: function () {
      $(document).on("change", "#road_voyage_contract_type", function() {
        Voyage.set_vehicle_view();
      });
      $(document).on("change", "#rorotruck_rorotruck_type", function() {
        set_truck_trailer_driver();
      });
      set_truck_trailer_driver();
      $(document).on('change', '#road_voyage_send_sms_message', function(event) {
        Voyage.set_sms_view();
      });
      $(document).on('change', '#road_voyage_voyage_type', function(event) {
        Voyage.set_positions_view();
      });
      Voyage.set_vehicle_view();
    },
    set_vehicle_view: function () {
      set_vehicle_view();
    },
    set_sms_view: function () {
      set_sms_view();
    },
    set_positions_view: function () {
      set_positions_view();
    }
  };
}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = Voyage;
}
